import { useState, useEffect } from 'react'
import {
  StyledDropdownContainer,
  StyledMiniTitle,
  StyledPlayerImageContainer,
  StyledText,
} from './style'
import { useTranslation } from 'react-i18next'
import { IPersonalDetails } from 'types/interfaces/IPersonalDetails'
import { IfavoritePlayer } from 'types/interfaces/IfavoritePlayerOptions'
import { favoritePlayerOptions } from 'shared/constants/favoritePlayerOptions'
import FavoritePlayerImage from 'shared/components/favorite-player-image/FavoritePlayerImage'
import { ELanguage } from 'types/enums/ELanguage'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'

interface PlayerImageProps {
  userDetails: IPersonalDetails
  onChange: (playerImage: number) => Promise<void>
  isEdit?: boolean
}

export const FavPlayerImage = ({
  userDetails,
  isEdit,
  onChange,
}: PlayerImageProps) => {
  const { t, i18n } = useTranslation('', {
    keyPrefix: 'pages.personalArea.tabs.personalDetails',
  })
  const [currentImageId, setCurrentImageId] = useState(userDetails.playerImage)
  const [isHebrew, setisHebrew] = useState(
    i18n.language === ELanguage.HEBREW ? true : false,
  )
  useEffect(() => {
    setCurrentImageId(userDetails.playerImage)

    setisHebrew(i18n.language === ELanguage.HEBREW ? true : false)
  }, [userDetails.playerImage, i18n.language])

  const handleDropdownChange = async (event: SelectChangeEvent<number>) => {
    const newImageId = Number(event.target.value)
    setCurrentImageId(newImageId)
    await onChange(newImageId)
  }

  return (
    <StyledPlayerImageContainer>
      <StyledMiniTitle>
        {isEdit ? t('details.imgEdit') : t('details.img')}
        <StyledText>{t('details.imgSub1')}</StyledText>
        <StyledText>{t('details.imgSub2')}</StyledText>
      </StyledMiniTitle>

      <StyledDropdownContainer>
        <Select
          style={{
            display: 'flex',
            fontSize: '14px',
            fontWeight: '400',
            height: '42px',
            padding: '11px 12px 12px 10px',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '4px',
            border: '1px solid #565656',
            color: '#000',
            width: '165px',
            fontFamily: 'Inter',
            backgroundColor: '#fff',
          }}
          value={currentImageId}
          onChange={handleDropdownChange}
        >
          {favoritePlayerOptions.map((image: IfavoritePlayer) => (
            <MenuItem
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: '400',
                width: '165px',
                borderRadius: '4px',
                fontFamily: 'Inter',
              }}
              key={image.id}
              value={image.id}
            >
              {isHebrew ? image.labelHebrew : image.label}
            </MenuItem>
          ))}
        </Select>
      </StyledDropdownContainer>
      <FavoritePlayerImage
        userDetails={{ ...userDetails, playerImage: currentImageId }}
      />
    </StyledPlayerImageContainer>
  )
}
